import type { IconSvgObject } from './types';

const ZodiacSagittariusIcon: IconSvgObject = [
  ["path", { d: "M3 21L20 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 9L15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 3.44251C13 3.44251 19.5617 2.44682 20.5574 3.44257C21.5532 4.43833 20.5574 11 20.5574 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ZodiacSagittariusIcon;
